<div class="app-shell">
	<header class="top-bar" role="banner">
		<div class="top-bar__left">
		</div>

		<div class="top-bar__brand" aria-label="Chevron brand">
			<img
				class="top-bar__logo"
				src="assets/branding/chevron-logo.svg"
				alt="Chevron logo"
			/>
			<a class="top-bar__title" routerLink="/">Sigmafine Reports</a>
		</div>

		@if (isLoggedIn) {
		<div class="top-bar__right">
			<img class="top-bar__user-icon" src="assets/branding/cvx_user.svg" alt="User icon" />
			<span class="top-bar__user-name">{{ currentUserProfile?.name || currentUserProfile?.email || 'User' }}</span>
		</div>
		}
	</header>

	<main class="page-content">
		<router-outlet />
	</main>
</div>
